import { getLocale } from "../runtime";

const sv_dalanguage = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Dansk`
};

const dalanguage = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_dalanguage(inputs)
	return "daLanguage";
};

export { dalanguage as "daLanguage" };